<template>
  <div class="profile-preferences">
    <SectionThreeItemsHeader class="mb-6 mt-2">
      <template v-slot:item-center>
        <h2>Preferences</h2>
      </template>
      <template v-slot:item-right>
        <EditPreferencesAction v-if="isEditable" />
      </template>
    </SectionThreeItemsHeader>
    <div v-if="isLoading" class="full-width">
      <v-skeleton-loader type="list-item-three-line" />
    </div>
    <div v-else>
      <Permissioned section="workers.edit" vertical>
        <LabeledText
          label="Contract Type"
          :permission="permissions.contractTypes"
        >
          <v-chip
            class="mr-2"
            v-for="(contractType, index) in userData.contractTypesGroupings"
            :key="index"
          >
            {{ contractType.name }}
          </v-chip>
        </LabeledText>
        <LabeledText
          label="Working Hours"
          :permission="permissions.workingHours"
        >
          <v-chip
            class="mr-2"
            v-for="(workingHour, index) in userData.workingHoursGroupings"
            :key="index"
          >
            {{ workingHour.name }}
          </v-chip>
        </LabeledText>
        <LabeledText label="Job Function" :permission="permissions.jobFunction">
          <v-chip
            class="mr-2"
            v-for="(experienceFunction, index) in userData.experienceFunctions"
            :key="index"
          >
            {{ experienceFunction.name }}
          </v-chip>
        </LabeledText>
        <LabeledText label="Location" :permission="permissions.location">
          <v-chip
            class="mr-2"
            v-for="(location, index) in userData.locationGroupings"
            :key="index"
          >
            {{ location.name }}
          </v-chip>
        </LabeledText>
        <LabeledText label="Minimum Salary" :permission="permissions.salary">
          <div v-if="isNumber(userData.minimumSalaryPreference)">
            {{ userData.minimumSalaryPreference | currency("GBP") }}
          </div>
        </LabeledText>
      </Permissioned>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import Permissioned from "@/components/common/Permissioned";
import LabeledText from "@/components/common/BaseDetails/LabeledText";
import EditPreferencesAction from "@/views/settings/components/actions/EditPreferencesAction";
import SectionThreeItemsHeader from "@/components/common/SectionThreeItemsHeader/SectionThreeItemsHeader";
import { USERS_NAMESPACE } from "@/store/modules/users";
import { GET_IS_EDITING_USER_DETAILS } from "@/store/modules/users/getters";
import { PERMISSIONS } from "@/constants/workers";
import { isNumber } from "lodash";

const { mapGetters: mapUserGetters } = createNamespacedHelpers(USERS_NAMESPACE);

export default {
  components: {
    LabeledText,
    Permissioned,
    EditPreferencesAction,
    SectionThreeItemsHeader
  },
  props: {
    userData: {
      type: Object,
      required: true
    },
    isEditable: Boolean
  },
  data() {
    return {
      permissions: PERMISSIONS.PREFERENCES
    };
  },
  computed: {
    ...mapUserGetters({
      isLoading: GET_IS_EDITING_USER_DETAILS
    })
  },
  methods: {
    isNumber
  }
};
</script>

<style lang="scss"></style>
